import { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { useAuth } from '../../auth/AuthContext';
import { etiquetaRol } from '../../auth/roles';
import useCerrarConEscapeYClickAfuera from '../../hooks/useCerrarConEscapeYClickAfuera';
import useInertFondo from '../../hooks/useInertFondo';

// Drawer "Más" a pantalla completa: árbol completo de menuSections (ya filtrado por permiso
// en NavegacionMobile, mismo resultado que usa el riel de escritorio) en grupos colapsables,
// más el bloque de usuario (Mi Perfil / Cerrar Sesión) que en escritorio solo vive en el
// dropdown de NavegacionLateral.js — sin este bloque esas dos acciones desaparecerían en mobile.
export default function DrawerMas({ seccionesVisibles, onCerrar }) {
    const { user, logout } = useAuth();
    const [gruposAbiertos, setGruposAbiertos] = useState(() => new Set());
    const contenedorRef = useRef(null);
    const tituloRef = useRef(null);

    useCerrarConEscapeYClickAfuera(contenedorRef, true, onCerrar);
    useInertFondo(true);

    useEffect(() => {
        const elementoPrevio = document.activeElement;
        tituloRef.current?.focus();
        return () => {
            if (elementoPrevio && typeof elementoPrevio.focus === 'function') {
                elementoPrevio.focus();
            }
        };
    }, []);

    const toggleGrupo = (id) => {
        setGruposAbiertos((prev) => {
            const siguiente = new Set(prev);
            if (siguiente.has(id)) siguiente.delete(id);
            else siguiente.add(id);
            return siguiente;
        });
    };

    return (
        <>
            <div className="mob-overlay-backdrop" />
            <div className="mob-sheet" ref={contenedorRef} role="dialog" aria-modal="true" aria-label="Menú">
                <div className="mob-sheet-header">
                    <h2 className="mob-sheet-titulo" ref={tituloRef} tabIndex={-1}>Menú</h2>
                    <button
                        type="button"
                        className="mob-sheet-boton-cerrar mob-tocable"
                        onClick={onCerrar}
                        aria-label="Cerrar menú"
                    >
                        <i className="bi bi-x-lg" aria-hidden="true" />
                    </button>
                </div>

                <div className="mob-sheet-body">
                    {user && (
                        <>
                            <div className="mob-drawer-usuario">
                                <FaUserCircle className="mob-drawer-usuario-icono" aria-hidden="true" />
                                <div>
                                    <div className="mob-drawer-usuario-nombre">{user.nombre}</div>
                                    <div className="mob-drawer-usuario-rol">{etiquetaRol(user.rol)}</div>
                                </div>
                            </div>
                            <div className="mob-drawer-usuario-acciones">
                                <NavLink to="/mi-perfil" className="mob-drawer-usuario-accion mob-tocable" onClick={onCerrar}>
                                    <i className="bi bi-person-circle" aria-hidden="true" />
                                    Mi Perfil
                                </NavLink>
                                <button
                                    type="button"
                                    className="mob-drawer-usuario-accion mob-drawer-cerrar-sesion mob-tocable"
                                    onClick={logout}
                                >
                                    <i className="bi bi-box-arrow-right" aria-hidden="true" />
                                    Cerrar Sesión
                                </button>
                            </div>
                        </>
                    )}

                    {seccionesVisibles.map((section) => {
                        const abierto = gruposAbiertos.has(section.id);
                        return (
                            <div key={section.id}>
                                <button
                                    type="button"
                                    className="mob-drawer-grupo-header mob-tocable"
                                    onClick={() => toggleGrupo(section.id)}
                                    aria-expanded={abierto}
                                >
                                    <i className={section.icon} aria-hidden="true" />
                                    {section.title}
                                    <i className="bi bi-chevron-down mob-drawer-chevron" aria-hidden="true" />
                                </button>
                                {abierto && (
                                    <div>
                                        {(section.items || []).map((item) => (
                                            <NavLink
                                                key={item.to}
                                                to={item.to}
                                                onClick={onCerrar}
                                                className={({ isActive }) => `mob-drawer-item ${isActive ? 'active' : ''}`}
                                            >
                                                <i className={item.icon} aria-hidden="true" />
                                                <span>{item.label}</span>
                                            </NavLink>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
